var irreducible = require('./irreducible');
var isType = require('./isType');

module.exports = irreducible('Type', isType);


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb/lib/Type.js
// module id = 2109
// module chunks = 69